"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SelectedFormatter;

var _Checkbox2 = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _dataGrid = require("@kontenbase/data-grid");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

SelectedFormatter.propTypes = _propTypes.EditorProps;

function SelectedFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column;

  var _useRowSelection = (0, _dataGrid.useRowSelection)(),
      _useRowSelection2 = _slicedToArray(_useRowSelection, 2),
      isRowSelected = _useRowSelection2[0],
      onRowSelectionChange = _useRowSelection2[1]; // const isEditable = column.isEditable;


  var handleChange = function handleChange(e) {
    var checked = e.target.checked;
    var isShiftClick = e.nativeEvent.shiftKey;
    onRowSelectionChange({
      row: row,
      checked: checked,
      isShiftClick: isShiftClick
    });
  };

  var stopPropagation = function stopPropagation(event) {
    event.stopPropagation();
  };

  var value = row[column.key]; // detect value is component

  if (_typeof(value) === "object") {
    return value;
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: isRowSelected ? "" : "rdg-selected",
    style: {}
  }, /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement(_Checkbox2["default"], {
    tabIndex: -1,
    color: "primary",
    inputProps: {
      "aria-label": "primary checkbox"
    },
    onChange: handleChange,
    onClick: stopPropagation,
    checked: isRowSelected,
    size: "small",
    style: {
      padding: 0,
      marginLeft: 8
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: 12
    }
  }, value));
}